<template>
  <div>
    <div
      :class="{
        'flex justify-center': showCentered,
        'inline-flex flex-wrap': !showCentered,
      }"
    >
      <span
        v-if="comparePrice && comparePrice.amount > 0"
        class="inline-block self-end mr-3 text-gray-600 line-through decoration-blackly font-light leading-none"
        :class="largeTextClass"
      >
        {{
          $n(parseFloat(comparePrice.amount), {
            style: 'currency',
            currency: comparePrice.currencyCode,
          })
        }}
      </span>
      <span
        v-if="price && price.amount >= 0"
        class="relative inline-block self-end font-medium leading-none"
        data-testid="price"
        :class="[comparePrice && comparePrice.amount > 0 ? smallTextClass : largeTextClass, showVatHint ? 'mr-2' : '']"
      >
        {{
          $n(parseFloat(price.amount), {
            style: 'currency',
            currency: price.currencyCode,
          })
        }}

        <ProductSavingsLabel
          v-if="showProductsSavingsLabel"
          :variant="savingsLabelVariant"
          class="absolute left-1/2 -translate-x-1/2 top-full mt-2"
        >
          <span v-if="textForSavingsLabel?.length">{{ textForSavingsLabel }}</span>
          <span v-else-if="savings">
            {{ $t('savingsLabel') }}
            {{
              $n(savings, {
                style: 'currency',
                currency: price.currencyCode,
              })
            }}
          </span>
        </ProductSavingsLabel>
      </span>
      <span v-if="showVatHint" class="text-blackly self-end inline-block whitespace-nowrap fluid-xs leading-none">{{
        $t('vatIncl')
      }}</span>
    </div>

    <!-- Placeholder for Product Savigns Label -->
    <div v-if="showProductsSavingsLabel" class="h-6"></div>

    <ProductCardUnitPrice
      v-bind="{ unitPrice, unitPriceMeasurement, showQuantity, size, showMeasurement: price.amount > 0 }"
    />
  </div>
</template>

<script>
import ProductCardUnitPrice from '~/components/shop/products/ProductCardUnitPrice.vue';
import ProductSavingsLabel from '~/components/shop/products/ProductSavingsLabel.vue';
import { useGlobalBannerStore } from '@/stores/global-banner';

export default defineNuxtComponent({
  components: { ProductCardUnitPrice, ProductSavingsLabel },

  setup() {
    const globalBannerStore = useGlobalBannerStore();
    return { globalBannerStore };
  },

  props: {
    price: {
      type: Object,
      default: () => {},
    },
    comparePrice: {
      type: Object,
      default: () => {},
    },
    unitPrice: {
      type: Object,
      default: () => {},
    },
    unitPriceMeasurement: {
      type: Object,
      default: () => {},
    },
    showQuantity: {
      type: Boolean,
      default: false,
    },
    showVatHint: {
      type: Boolean,
      default: true,
    },
    showCentered: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'lg',
      validator: (value) => ['xs', 'sm', 'lg'].includes(value),
    },
    showSavings: {
      type: Boolean,
      default: null,
    },
    savingsLabelVariant: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'bordered'].includes(value),
    },
  },

  computed: {
    textForSavingsLabel() {
      return this.globalBannerStore.textForSavingsLabel;
    },

    showProductsSavingsLabel() {
      if (this.showSavings === false) return false;
      return (
        (this.textForSavingsLabel?.length > 0 && this.comparePrice?.amount > 0) ||
        (this.showSavings && this.savings > 0)
      );
    },

    savings() {
      if (this.price?.amount && this.comparePrice?.amount) {
        return parseFloat(this.comparePrice.amount) - parseFloat(this.price.amount);
      }
      return 0;
    },

    largeTextClass() {
      if (this.size === 'lg') {
        return 'fluid-xl';
      } else if (this.size === 'sm') {
        return 'fluid-lg font-medium';
      } else {
        return 'fluid-sm';
      }
    },

    smallTextClass() {
      if (this.size === 'lg') {
        return 'fluid-lg font-light';
      } else if (this.size === 'sm') {
        return 'text-md';
      } else {
        return 'text-[12px]';
      }
    },
  },
});
</script>
